<template>
  <header class="site-header">
    <!-- Desktop Navigation -->
    <nav class="navbar navbar-expand-lg">
      <div class="container">
        <!-- Branding -->
        <router-link to="/" class="navbar-brand">
          <span class="brand-text">FoodCycle.ai</span>
        </router-link>

        <!-- Hamburger Menu Toggle -->
        <button 
          class="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#mainNavigation" 
          aria-controls="mainNavigation" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Navigation Items -->
        <div class="collapse navbar-collapse" id="mainNavigation">
          <ul class="navbar-nav mx-auto">
            <li class="nav-item">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/tool">Tool</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/tool-description">About</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://foodcycle.ai/education-material/" target="_blank">Education Material</a>
            </li>
          </ul>

          <!-- Login/User Dropdown -->
          <div class="nav-auth">
            <div v-if="authStore.isLoggedIn" class="dropdown">
              <button 
                class="btn btn-user-menu dropdown-toggle" 
                type="button" 
                id="userDropdown" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
              >
                <i class="bi bi-person-circle me-2"></i>
                Account
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li>
                  <router-link class="dropdown-item" to="/account-settings">
                    <i class="bi bi-gear me-2"></i>
                    Account Settings
                  </router-link>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item text-danger" href="#" @click.prevent="handleDeleteAccount">
                    <i class="bi bi-trash me-2"></i>
                    Delete Account
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="logout">
                    <i class="bi bi-box-arrow-right me-2"></i>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
            <div v-else>
              <router-link to="/login" class="btn btn-outline-primary">
                <i class="bi bi-box-arrow-in-right me-1"></i> Login
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { useAuthStore } from '../stores/auth';
import { useRouter } from 'vue-router';

export default {
  name: 'Header',
  setup() {
    const router = useRouter();
    const authStore = useAuthStore();

    const logout = () => {
      authStore.logout();
      router.push('/login');
    };

    const handleDeleteAccount = () => {
      router.push('/account-settings');
    };

    return {
      authStore,
      logout,
      handleDeleteAccount,
    };
  }
};
</script>

<style scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.navbar {
  background-color: white;
  padding: 1rem;
  border-bottom: 3px solid #87b140;
}

.navbar-brand {
  display: flex;
  align-items: center;
  font-weight: 800;
  font-size: 1.5rem;
  color: #333;
  text-decoration: none;
}

.brand-text {
  position: relative;
  z-index: 1;
  color: #87b140;
}

.navbar-toggler {
  border: none;
  color: #333;
}

.nav-link {
  color: #555 !important;
  font-weight: 500;
  padding: 0.5rem 1.2rem;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover, .nav-link.router-link-active {
  color: #87b140 !important;
}

.nav-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 50%;
  background-color: #87b140;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.nav-link:hover::after, .nav-link.router-link-active::after {
  width: 80%;
}

.nav-auth .btn {
  border-color: #87b140;
  color: #87b140;
  transition: all 0.3s ease;
}

.nav-auth .btn:hover {
  background-color: #87b140;
  color: white;
}

/* User Dropdown Styles */
.btn-user-menu {
  background-color: transparent;
  color: #87b140;
  border: 1px solid #87b140;
  border-radius: 20px;
  padding: 0.375rem 1rem;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.btn-user-menu:hover,
.btn-user-menu:focus {
  background-color: #87b140;
  color: white;
  border-color: #75a236;
}

.dropdown-menu {
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  min-width: 180px;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f2f5e7;
  color: #87b140;
}

.dropdown-item.text-danger:hover {
  background-color: #fee;
  color: #dc3545;
}

@media (max-width: 768px) {
  .navbar-collapse {
    padding: 1rem;
    border-radius: 0 0 0.5rem 0.5rem;
    margin-top: 0.5rem;
  }
  
  .nav-auth {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }
}
</style>